module.exports = __webpack_public_path__ + "img/1.628176b2.png";